import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface DSSortState {
  sortValue: string
  ownFirst: boolean
  setSortValue: (sortValue: string) => void
  setOwnFirst: (sortValue: boolean) => void
}

export const useDSSortStore = create<DSSortState>()(
  persist(
    (set) => ({
      sortValue: "tvl_d",
      setSortValue: (sortValue: string) => set({ sortValue }),
      ownFirst: true,
      setOwnFirst: (ownFirst: boolean) => set({ ownFirst })
    }),
    {
      name: 'ds-sort-storage', // key in localStorage
    }
  )
)
